import React from 'react'
import Separator from '../../helpers/Separator'
import { useAccordionState } from './AccordionHandler'

const AccordionContent = ({ children, noSeparator, separatorWeight, ...props }) => {
  const { open } = useAccordionState()

  if (!open) return false

  return (
    <div>
      {!noSeparator && <Separator weight={separatorWeight || 8} />}
      {children}
    </div>
  )
}

export default AccordionContent
